export const defaultMeterFormat = new Intl.NumberFormat(undefined, {
    style: "unit",
    maximumFractionDigits: 2,
    unit: "meter",
});
export const defaultKilometerFormat = new Intl.NumberFormat(undefined, {
    style: "unit",
    maximumFractionDigits: 2,
    unit: "kilometer",
});
/**
 * Format length
 *
 * @param length Length in meters
 * @param options options
 * @returns The formatted length string
 */
export function formatLength(length, { meterFormat = defaultMeterFormat, kilometerFormat = defaultKilometerFormat, } = {}) {
    const isKilometer = length > 1000;
    const format = isKilometer ? kilometerFormat : meterFormat;
    const amount = isKilometer ? length / 1000 : length;
    return format.format(amount);
}
